<template>
  <div v-if="ipa || simplified" class="inline-flex items-center gap-2 text-xs">
    <span v-if="simplified" class="text-gray-500">{{ simplified }}</span>
    <!-- .stop: this guide renders inside click-to-flip flashcards, where tapping
         IPA was revealing the answer. A self-contained toggle should never fire
         a parent's handler. -->
    <button
      v-if="ipa"
      @click.stop="toggleIpa"
      class="text-[10px] font-mono px-1.5 py-0.5 rounded border transition-colors"
      :class="showIpa
        ? 'bg-emerald-50 border-emerald-300 text-emerald-700'
        : 'bg-gray-50 border-gray-200 text-gray-400 hover:border-gray-300 hover:text-gray-500'"
      :title="showIpa ? 'Hide IPA' : 'Show IPA'"
    >
      IPA
    </button>
    <span v-if="ipa && showIpa" class="font-mono text-gray-400">{{ ipa }}</span>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

defineProps({
  ipa: { type: String, default: null },
  simplified: { type: String, default: null },
})

const STORAGE_KEY = 'speaksaigon_show_ipa'
const showIpa = ref(false)

onMounted(() => {
  showIpa.value = localStorage.getItem(STORAGE_KEY) === 'true'
})

function toggleIpa() {
  showIpa.value = !showIpa.value
  localStorage.setItem(STORAGE_KEY, showIpa.value)
}
</script>
